<template>
  <div data-qa="paymentsuccessdialog-div-c5fvov">
    <v-dialog
      :value="show"
      persistent
      width="700"
     data-qa="paymentsuccessdialog-dialog-m83x1o">
      <v-card data-qa="paymentsuccessdialog-card-i0qnh">
        <v-container data-qa="paymentsuccessdialog-container-7ivap">
          <v-card-text class="text-center" data-qa="paymentsuccessdialog-card-text-iniakn7">
            <v-avatar color="green lighten-5" size="64" class="mb-4" data-qa="paymentsuccessdialog-avatar-u7lyag">
              <v-icon x-large color="green darken-4" class="centered-icon" data-qa="paymentsuccessdialog-icon-1igzxh">mdi-check</v-icon>
            </v-avatar>
            <p class="text-h4 font-weight-black" data-qa="paymentsuccessdialog-p-twja6k">{{ computedTitle }}</p>
            <p class="text-subtitle-1 mb-1" v-show="computedSubtitle" data-qa="paymentsuccessdialog-p-5o70ta">{{ computedSubtitle }}</p>
            <p class="text-subtitle-1" data-qa="paymentsuccessdialog-p-bc1kd9">
              {{ computedReferenceTitle }} <span class="reference" data-qa="paymentsuccessdialog-span-xwaljp">{{ referenceId }}</span>
            </p>
          </v-card-text>

          <v-card-text data-qa="paymentsuccessdialog-card-text-kdccc">
            <div class="mx-6 mt-0" data-qa="paymentsuccessdialog-div-b816a">
              <DisplayDetails
                :config="{
                  title: '',
                  dataList,
                  translation: dataListTranslation || null,
                  screenType: 'confirmScreen'
                }"
              />
            </div>
          </v-card-text>

          <v-row class="justify-center mt-3" data-qa="paymentsuccessdialog-row-7fvqj4">
            <v-col cols="4" class="d-flex justify-center align-center" data-qa="paymentsuccessdialog-col-ck6ix8">
              <v-btn
                dark
                :color="primaryColor"
                class="text-capitalize py-2 px-4"
                @click="$emit('createNewTransfer')"
               data-qa="paymentsuccessdialog-btn-v2nyv6">
                <v-icon left size="18px" class="material-symbols-outlined" data-qa="paymentsuccessdialog-icon-imgmb">add</v-icon>
                {{ resource.button.newTransfer }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="justify-center mt-0" data-qa="paymentsuccessdialog-row-96770m">
            <v-col cols="4" class="d-flex justify-center align-center" data-qa="paymentsuccessdialog-col-6dzg2i">
              <v-btn
                text
                :color="primaryColor"
                @click="$emit('gotoDashboard')"
                class="text-capitalize py-2 px-4"
               data-qa="paymentsuccessdialog-btn-p7w3ub">
                {{ resource.button.gotoDashboard }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import DisplayDetails from '@/views/common/DisplayDetails.vue'

export default {
  name: 'PaymentSuccessDialog',
  props: {
    show: Boolean,
    title: String,
    subtitle: String,
    hideSubtitle: Boolean,
    referenceTitle: String,
    referenceId: String,
    dataList: Array,
    dataListTranslation: String
  },
  components: {
    DisplayDetails
  },
  computed: {
    resource () {
      return {
        transferInitiated: this.$t('paymentSuccessDialog.transferInitiated'),
        underProcessing: this.$t('paymentSuccessDialog.underProcessing'),
        yourTransactionReference: this.$t('paymentSuccessDialog.yourTransactionReference'),
        button: {
          newTransfer: this.$t('paymentSuccessDialog.button.newTransfer'),
          gotoDashboard: this.$t('paymentSuccessDialog.button.gotoDashboard')
        }
      }
    },
    computedTitle () {
      return this.title || this.resource.transferInitiated
    },
    computedSubtitle () {
      if (this.hideSubtitle) {
        return null
      }
      return this.subtitle || this.resource.underProcessing
    },
    computedReferenceTitle () {
      return this.referenceTitle || this.resource.yourTransactionReference
    }
  }
}
</script>

<style scoped>
.reference {
  color: rgba(193, 55, 162, 1);
  font-size: 18px;
}
.centered-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
